import React, { useEffect, useReducer, useRef, useState } from 'react';
import type { ITextFieldProps } from './TextField.types';
import cn from 'classnames';

// REDUX
import { useAppSelector, useAppDispatch } from '@Managers/Redux/Hooks';
import { getDeviceInfo, getGlobalStyles, setGlobalStyles } from '@Managers/Redux/AppState/AppState';

import styles from '@UILayer/UILayer.scss';
//import { useDispatch } from 'react-redux';

const TextField: React.FC<ITextFieldProps> = ({ children, onResizeEnd, useSpanElement = false, ofHeightValue = 1 }) => {
    const [state, setState] = useReducer((state: { stringLenght: number }, newState: any) => ({ ...state, ...newState }), {
        stringLenght: 0
    });

    //const dispatch = useAppDispatch();
    const globalStyles = useAppSelector(getGlobalStyles);
    const device = useAppSelector(getDeviceInfo);
    const classes = cn(styles.text_field_container, globalStyles.wcaMode, globalStyles.orientation, useSpanElement ? styles.text_field_span : false);
    const textInput = useRef(null);
    const maxTriesValue = 1000;
    const cssErrorMarginValue = 2;

    function checkFontHeight(container: HTMLElement) {
        const parentElement = container.parentElement;
        const staticHeightPadding = 2;
        let fontSize = parseInt(window.getComputedStyle(container, null).getPropertyValue('font-size'));
        let maxTries = 0;

        if (parentElement) {
            const getTargetHeight = Math.round(parentElement.getBoundingClientRect().height / ofHeightValue - staticHeightPadding);

            while (container.clientHeight - cssErrorMarginValue > getTargetHeight && maxTries <= maxTriesValue) {
                fontSize--;
                container.style.fontSize = fontSize + 'px';
                maxTries++;

                if (maxTries > maxTriesValue) console.warn('dynamic font size loop');
            }
            if (onResizeEnd) onResizeEnd(fontSize);
        }
    }

    function adjustFontSize(container: HTMLElement, desiredWidth: number) {
        container.removeAttribute('style');
        let fontSize = parseInt(window.getComputedStyle(container, null).getPropertyValue('font-size'));
        let prevFontSize = 0;
        let maxTries = 0;

        while (container.scrollWidth > desiredWidth && fontSize > 0 && maxTries <= maxTriesValue) {
            fontSize--;
            prevFontSize = fontSize;
            container.style.fontSize = fontSize + 'px';
            maxTries++;

            if (maxTries > maxTriesValue) console.warn('dynamic font size loop');
        }
        checkFontHeight(container);
    }

    useEffect(() => {
        const strLgt = children?.toLocaleString().length;

        if (textInput.current) {
            if (state.stringLenght !== strLgt) {
                setState({
                    stringLenght: strLgt
                });
                adjustFontSize(textInput.current, (textInput.current as HTMLElement).offsetWidth);
            }
        }
    }, [children]);

    useEffect(() => {
        if (textInput.current) {
            // HACK FOR MISSING FIELD - PROBABLY ISSUE WITH REACT RE-RENDER - F2-645
            setTimeout(() => {
                if (textInput.current) {
                    adjustFontSize(textInput.current, (textInput.current as HTMLElement).offsetWidth);
                }
            }, 1);
        }
    }, [device]);

    return (
        <>
            {useSpanElement ? (
                <span ref={textInput} className={classes} style={{}}>
                    {children}
                </span>
            ) : (
                <div ref={textInput} className={classes} style={{}}>
                    {children}
                </div>
            )}
        </>
    );
};

export default TextField;
